import { GrcNotify, NotifyType } from '@grc/ui-package';
import { tenantService } from '../../common/constants/constants';
import { businessEntityUrl } from '../../common/constants/url-constants';

const inflightBusinessEntities = new Map<string, Promise<any>>();

export const getBusinessEntities = async (fetchData: any, data: any) => {
  try {
    const queryParams = new URLSearchParams();

    queryParams.append('status', data.status);

    if (data.name) {
      queryParams.append('name', data.name);
    }

    if (data.entityType) {
      queryParams.append('entityType', data.entityType);
    }

    if (data.entityIds && data.entityIds.length > 0) {
      Array.from(new Set<string>(data.entityIds)).forEach((id: string) => {
        queryParams.append('entityIds', id);
      });
    }

    if (data.accountId) {
      queryParams.append('accountId', data.accountId);
    }

    if (
      data.locationOwnershipType &&
      Array.isArray(data.locationOwnershipType)
    ) {
      data.locationOwnershipType.forEach((type: number) => {
        queryParams.append('locationOwnershipType', type.toString());
      });
    }

    if (data.includeHierarchyLocations) {
      queryParams.append(
        'includeHierarchyLocations',
        data.includeHierarchyLocations
      );
    }

    if (data.locationIds && data.locationIds.length > 0) {
      Array.from(new Set<string>(data.locationIds)).forEach((id: string) => {
        queryParams.append('locationIds', id);
      });
    }

    if (data.onlyParentEntities) {
      queryParams.append('onlyParentEntities', data.onlyParentEntities);
    }

    const queryString = queryParams.toString();
    const urlWithParams = `${businessEntityUrl}?${queryString}`;

    const existing = inflightBusinessEntities.get(urlWithParams);
    if (existing) return existing;

    const request = fetchData(
      urlWithParams,
      (message: any) => GrcNotify({ message, status: NotifyType.Error }),
      tenantService
    )
      .then((response: any) =>
        response?.data?.length > 0 ? response.data : []
      )
      .catch((error: any) => {
        GrcNotify({ message: error.message, status: NotifyType.Error });
        return undefined;
      })
      .finally(() => {
        inflightBusinessEntities.delete(urlWithParams);
      });

    inflightBusinessEntities.set(urlWithParams, request);
    return request;
  } catch (error: any) {
    GrcNotify({
      message: error.message,
      status: NotifyType.Error
    });
    return undefined;
  }
};
